import React from "react";
import BaseCard from "@/components/cards/BaseCard";

/**
 * IndustryCard — sector card for /industries index and related blocks.
 * Props: { slug, name, blurb, image? }
 */
const IndustryCard = ({ slug, name, blurb, image }) => (
  <BaseCard
    to={`/industries/${slug}`}
    variant={image ? "photo" : "flat"}
    image={image}
    eyebrow="Industry"
    title={name}
    blurb={blurb}
    testid={`industry-card-${slug}`}
  />
);

export default IndustryCard;
